import styled from '@emotion/styled';
import { Card as SemanticCard } from 'semantic-ui-react';

const StyledCard = styled(SemanticCard)<CardProps>`
	&.ui.card {
		border: 0;
		background-color: white;
		width: auto;
		border-radius: 15px;
		margin: ${props => ['t', 'a'].includes(props.marginy ?? '') ? '16px' : 0} ${props => ['r', 'a'].includes(props.marginx ?? '') ? '16px' : 0} ${props => ['b', 'a'].includes(props.marginy ?? '') ? '16px' : 0} ${props => ['l', 'a'].includes(props.marginx ?? '') ? '16px' : 0};
		padding: 0;
	}
`;

interface CardProps {
	marginx?: 'l' | 'b' | 'a',
	marginy?: 't' | 'b' | 'a'
}

export const Card: React.FC<CardProps> = ({ marginx, marginy, children }) => (
	<StyledCard marginx={marginx} marginy={marginy} >
		<SemanticCard.Content>{children}</SemanticCard.Content>
	</StyledCard>
);
